import { useTranslation } from 'react-i18next';
import {
  // usePolicyDropDown,
  useGetHistoryRequest,
  useChangeReqstHistory,
} from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { useEffect, useState } from 'react';
import { Row, Col, Select, Collapse } from 'antd';
import styled from 'styled-components';
import './Liststyle.less';
const { Panel } = Collapse;
import { isLocaleEnglish } from 'utils/languageUtils';
import { changeDataFun } from 'utils/changeDataFun';
const StyledBlock = styled.div<{ bottom?: string }>`
  width: 100%;
  margin-bottom: ${(props) => (props.bottom ? props.bottom : '1rem')};
`;
const Androw = styled(Row)<{ bc?: boolean; shadow?: boolean }>`
  max-width: 640px;
  margin: 0 auto !important;
  background: ${(props) => (props.bc ? '#fff' : 'transparent')};
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 6px;
  box-shadow: ${(props) => (props.shadow ? '0px 2px 4px 0px #00000033' : 'none')};
`;

function HistoryList(props: { policyNo?: string; cCode?: string }) {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const [randoms, setRandoms] = useState(Math.random());
  const [policyNumber, setPolicyNumber] = useState<string>();
  const [companyCode, setCompanyCode] = useState<string>();
  const { token } = useKeycloakReady();
  const [expend, setExpend] = useState({
    activeId: '',
    bool: false,
  });
  const {
    shouldFetch: shouldFecthDrop,
    data: dropData,
    // isLoading: dropDataisLoading,
  } = useGetHistoryRequest('useGetHistoryRequest', token || '');
  const {
    shouldFetch: changeReqstHistoryFetch,
    data: changeReqstHistoryData,
    // error: changeReqstHistoryError,
  } = useChangeReqstHistory('useChangeReqstHistory' + randoms, token ?? '', policyNumber, companyCode);
  const [policyTypesObject, setPolicyTypesObject] =
    useState<{ companyCode: string; policyNumber: string; productName: string; productNameTC: string }[]>();
  useEffect(() => {
    shouldFecthDrop(true);
    setRandoms(Math.random());
    changeReqstHistoryFetch(true);
  }, [shouldFecthDrop, changeReqstHistoryFetch]);
  useEffect(() => {
    if (dropData) {
      const list = [
        {
          companyCode: '',
          policyNumber: '',
          productName: 'All Policies',
          productNameTC: '所有保單',
        },
        ...dropData,
      ];
      setPolicyTypesObject(list);
    }
  }, [dropData]);
  useEffect(() => {
    if (props.policyNo && props.cCode) {
      setPolicyNumber(props.policyNo);
      setCompanyCode(props.cCode);
      setRandoms(Math.random());
      changeReqstHistoryFetch(true);
    }
  }, [props, changeReqstHistoryFetch]);
  const changePolicy = (value: string) => {
    setPolicyNumber(value);
    if (value != '') setCompanyCode(dropData?.filter((item) => item.policyNumber === value)[0].companyCode);
    else setCompanyCode('');
    setRandoms(Math.random());
    changeReqstHistoryFetch(true);
  };
  type Iform = {
    [key: string]: string;
  };
  const colorsMap: Iform = {
    Rejected: '#AF2219',
    Submitted: '#E9583D',
    Processing: '#FFA006',
    Completed: '#7ED320',
    Cancelled: '#AF2219',
    Pending: '#FFA006',
  };
  return (
    <div className="history-list">
      <Row
        justify="center"
        gutter={[16, { xs: 8, sm: 8, lg: 16 }]}
        style={{ marginTop: '40px' }}
        className="history select-policy-history"
      >
        <Col xs={24} md={24} style={{ display: 'contents' }}>
          <Select
            placeholder={t('life.MakeRequest.Allpolicies')}
            defaultValue={props.policyNo}
            className="policySelect"
            popupClassName="slectop"
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              width: '640px',
            }}
            onChange={changePolicy}
          >
            {policyTypesObject &&
              policyTypesObject.map((item) => (
                <Select.Option key={item.policyNumber} value={item.policyNumber}>
                  <div style={{ display: 'grid' }} className={item.policyNumber != '' ? '' : 'textcenter'}>
                    <span>{isEnglish ? item.productName : item.productNameTC}</span>
                    {item.policyNumber != '' && (
                      <span>
                        {t('life.enquiry.policyNo')}
                        {item.policyNumber}
                      </span>
                    )}
                  </div>
                </Select.Option>
              ))}
          </Select>
        </Col>
      </Row>
      {/* <StyledBlock>
        <Androw justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="history">
          <Col span={24} className="font-setting500 grey-font font-size17">
            {t('Life.Policy.last180d')}
          </Col>
        </Androw>
      </StyledBlock> */}
      <StyledBlock bottom="5px">
        <Androw justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="history">
          <Col span={24}>
            <Collapse
              accordion
              expandIconPosition="end"
              onChange={(e) => {
                if (e) {
                  setExpend({
                    ...expend,
                    activeId: e as string,
                    bool: true,
                  });
                } else {
                  setExpend({
                    ...expend,
                    activeId: '',
                    bool: false,
                  });
                }
              }}
            >
              {changeReqstHistoryData &&
                changeReqstHistoryData.length > 0 &&
                changeReqstHistoryData?.map((item, index) => {
                  return (
                    <Panel
                      className={[
                        'weidu site-collapse-custom-panel',
                        // item.id + '' === expend.activeId && expend.bool ? 'active' : 'disactive',
                      ].join(' ')}
                      header={
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                          }}
                        >
                          <span className="headers_wd" style={{ backgroundColor: `${colorsMap[item.changeStatus]}` }}>
                            {isEnglish ? item.changeStatus : item.changeStatusTc}
                          </span>
                          <span className="headers_info">{isEnglish ? item.changeTypeEn : item.changeTypeTc}</span>
                        </div>
                      }
                      extra={isEnglish ? item.createTime : changeDataFun(item.createTime)}
                      key={index}
                    >
                      {item.policyNo && (
                        <p className="font-size17" style={{ marginBottom: '0', lineHeight: '22px' }}>
                          {(isLocaleEnglish(i18n.language) ? 'Policy number: ' : '保單號碼: ') +
                            (item.policyNo ? item.policyNo : '')}
                        </p>
                      )}
                      <p className="font-size17" style={{ marginBottom: '0', lineHeight: '22px' }}>
                        {(isEnglish ? 'Reference number: ' : '參考編號: ') +
                          (item.bpmReferenceNo ? item.bpmReferenceNo : '')}
                      </p>
                      <p
                        className="font-size17 font-setting500"
                        style={{ marginBottom: '0', marginTop: '8px', lineHeight: '22px' }}
                      >
                        {t('life.MakeRequest.lastat', {
                          time: isEnglish ? item.updateTime || '' : item.updateTime?.slice(0, -2) || '',
                          date: isEnglish ? item.updateDate || '' : changeDataFun(item.updateDate || ''),
                          timeSlot: (!isEnglish && (item.updateTime?.slice(-2) == 'AM' ? '上午' : '下午')) || '',
                        })}
                      </p>
                    </Panel>
                  );
                })}
            </Collapse>
          </Col>
        </Androw>
      </StyledBlock>
    </div>
  );
}
export default HistoryList;
